import { usePrevious } from '../use-previous';

export function usePreviousCompare<T>(next: T, compare: (previous: T | null, next: T | null) => boolean): boolean {
  const previous = usePrevious(next);
  return compare(previous, next);
}
